import React from "react"
import CustomAlert from "../../../../../ui/atoms/Alert"
import Stroke from "../../../../../ui/atoms/Stroke"
import { EditorialLabel } from "../../../../contents"
import { Basket } from "../../../state/checkoutTypes"
import OrderRecapItems from "../OrderRecapItems"
import PriceDetailsBox from "../PriceDetailsBox"

interface Props {
  basket: Basket
}

const OrderRecap = ({ basket }: Props) => {
  return (
    <>
      <CustomAlert
        severity="warning"
        show={(basket?.unavailableItems?.length ?? 0) > 0}
      >
        <EditorialLabel scope="basket" id="articles-not-available" />
      </CustomAlert>
      <OrderRecapItems basket={basket} />
      <div className="my-4">
        <Stroke color="disabled" />
      </div>
      <PriceDetailsBox basket={basket} />
    </>
  )
}

export default OrderRecap
